import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccountService } from '../../services/account.service';
import { PwaInstallService } from '../../services/pwa-install.service';
import { IosInstallDialogComponent } from '../../shared/modals/ios-install-dialog/ios-install-dialog.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderComponent {
  readonly localePair: [string, string];
  readonly localeLabels: [string, string];
  readonly version = environment.version;

  constructor(
    private accountService: AccountService,
    private pwaInstall: PwaInstallService,
    private dialog: MatDialog
  ) {
    const [first, second] = this.accountService.getLocales();
    this.localePair = [first, second];
    this.localeLabels = [first.toUpperCase(), second.toUpperCase()];
  }

  get installable(): boolean {
    return this.pwaInstall.installableValue && !this.pwaInstall.isRunningStandalone;
  }

  get installable$() {
    return this.pwaInstall.installable$;
  }

  get isStandalone(): boolean {
    return this.pwaInstall.isRunningStandalone;
  }

  get showIosInstall(): boolean {
    return this.pwaInstall.showIosInstall;
  }

  async installApp(): Promise<void> {
    if (this.pwaInstall.installableValue) {
      await this.pwaInstall.install();
    } else if (this.pwaInstall.showIosInstall) {
      this.dialog.open(IosInstallDialogComponent, { maxWidth: '420px' });
    }
  }

  get activeLocale(): string {
    return this.accountService.Locale;
  }

  localeSelected(locale: string) {
    this.accountService.setActiveLocale(locale);
  }
  getTranslation(key: string): string {
    switch (key) {
      case 'language-select': return $localize`:@@language-select:Select language`;
      default: return '';
    }
  }

  getLink(linkname: string):string {
    switch (linkname) {
      case 'support': return $localize`:@@einvoice.menuitem.link.support:`;
      default: return '#';
    }
  }
}
